'use client';

import { Button } from '@nextui-org/react';
import Image from 'next/image';

import { EmptyState } from '@/components/ui/empty-state/empty-state';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

export const NoAuthEmpty = () => {
  return (
    <EmptyState
      icon={
        <Image
          alt="empty"
          src="/empty/empty-no-auth.svg"
          width={300}
          height={300}
        />
      }
      title="Войдите или зарегистрируйтесь"
      description="Для просмотра страницы войдите или зарегистрируйтесь"
      bottom={
        <Link href={ROUTES.login}>
          <Button color="primary">Перейти к авторизации</Button>
        </Link>
      }
    />
  );
};
